export const navbarHeight = (sectionContainer : Element | null) => {
    const navbarHeight = (document.querySelector('.content-menu') as HTMLDivElement)?.offsetHeight;

    if (sectionContainer && navbarHeight) {
        const paddingSkill = parseInt(getComputedStyle(sectionContainer).paddingTop);

        (sectionContainer as HTMLDivElement).style.paddingTop = `${navbarHeight + paddingSkill }px`;
    }
}